
    export const TARGET_PASARAN_SELAMETAN = {};
    export const JENIS_SELAMETAN = [];
  